import { ColDef, type ICellRendererParams } from "ag-grid-community";
import { RdsSnapshotExistsCellRenderer } from "./RdsSnapshotExistsCellRenderer";
import { IsResourceBillableCellRenderer } from "../../column-def-cell-renderers/IsResourceBillableCellRenderer";
import { forecastedEOMColumnDef } from "../../common/forecastedEOMColumnDef";
import { resourceAccountColumnDef } from "../../common/resourceAccountColumnDef";
import { regionColumnDef } from "../../common/regionColumnDef";
import { DbPriceRationCellRenderer } from "../../column-def-cell-renderers/DbPriceRationCellRenderer";
import { FilteredRdsSnapshotSourceResourceItem } from "@/services//cloudchipr.api";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { billingCostColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/billingCostColumnDef";
import { getListingPriceColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";

export const rdsSnapshotSourceColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef("DB name"),

  forecastedEOMColumnDef,
  billingCostColumnDef,
  getListingPriceColumnDef("rds_snapshot_source"),

  resourceAccountColumnDef,

  {
    field: "resource.billable",
    headerName: "Billable",
    cellRenderer: IsResourceBillableCellRenderer,
  },

  {
    field: "resource.exists",
    headerName: "DB Status",
    cellRenderer: RdsSnapshotExistsCellRenderer,
  },
  {
    field: "resource.db_price_ratio",
    headerName: "Snapshots Price Ratio",
    headerTooltip:
      "Shows the monthly cost of RDS snapshots as a percentage of the database cost, helping you see how snapshot spending compares to your database. For example, if a database costs $5,000 per month and snapshots total $4,000, the ratio is 80%.",
    cellRenderer: ({
      data,
    }: ICellRendererParams<FilteredRdsSnapshotSourceResourceItem>) => {
      const resource = data?.resource;

      if (!resource) {
        return null;
      }

      return (
        <DbPriceRationCellRenderer
          dbPrice={resource?.db_price}
          dbPriceRatio={resource?.db_price_ratio}
        />
      );
    },
  },

  { field: "resource.db_type", headerName: "DB Type" },
  { field: "resource.snapshots_count", headerName: "Snapshots per DB" },
  { field: "resource.engine", headerName: "DB Engine" },

  regionColumnDef,
];
